import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, of, Subject, throwError } from 'rxjs';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { CommonService } from './common.service';
import { Injectable } from '@angular/core';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
@Injectable()
export class InterceptService implements HttpInterceptor {
  loader: any;
  service_count = 0;
  warningMessages = [
    'Record cannot be deleted because patient has open encounters.',
    'Cannot create encounter because the assigned vessel is inactive.',
    'Cannot create encounter because the assigned company is inactive.',
    'Form already linked to system, cannot delete.'
  ];

  constructor(
    private readonly toastr: ToastrService,
    private readonly commonService: CommonService,
    private readonly ngxUiLoaderService: NgxUiLoaderService,

  ) {
    this.loader = this.ngxUiLoaderService.getLoader();
  }
  /**
   * intercept all XHR request
   * @param request
   * @param next
   * @returns {Observable<A>}
   */
  static readonly serverError$ = new Subject<number>();
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.service_count++; 
    if (
      !request.url.includes('masters/patients/list') &&
      !request.url.includes('/masters?DdlType=') &&
      !request.url.includes('/masters?DdlType=Specialty') &&
      !request.url.includes('encounter/encounterSummary')
    ) {
      if (this.loader?.loaderId) {
        this.ngxUiLoaderService.startLoader(this.loader.loaderId);
      }
    }
    
    const userToken = localStorage.getItem('token');

    if (userToken) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${userToken}` },
      });
    }
    return next.handle(request).pipe(
      timeout(9000),
      finalize(() => {
        this.service_count--;

        if (this.service_count === 0) {
          if ( this.loader?.loaderId) {
            this.ngxUiLoaderService.stopLoader(this.loader.loaderId);

          }
        }
      }),
      catchError((error, caught) => {
        this.handleAuthError(error);
        return throwError(() => error);

      }) as any
    );
  }

  /**
   * manage-patients errors
   * @param err
   * @returns {any}
   */
  private handleAuthError(err: any, requestUrl?: string): Observable<any> {
    if (err.status === 401) {
      this.toastr.warning('Session timed out. Please log in again.', 'Warning!', {
        timeOut: 5000,
      });

      this.commonService.logout();
      return of(err.message);
    }

    if (err.status === 403) {
      setTimeout(() => {
        this.ngxUiLoaderService.stop();
      }, 500);

      this.toastr.error(err.error.message, 'Error!', {
        timeOut: 5000,
      });

      return of(err.message);
    }

    if (err.status === 500) {
      setTimeout(() => {
        if ( this.loader?.loaderId) {
          this.ngxUiLoaderService.stopLoader(this.loader.loaderId);
        } else {
          this.ngxUiLoaderService.stopAll()
        }
      }, 500);

      const message = err.error.Message ?? err.error.message;

      if (this.warningMessages.includes(message)) {
        this.toastr.warning(message, 'Warning!', {
          timeOut: 2000,
        });

        return throwError(() => err);
      }


      const msg = err.error.message ?? 'Something went wrong! Please contact system admin.';
      this.toastr.error(msg, 'Error!', { timeOut: 5000 });

      return throwError(() => err);;
    }

    if (err.status == 400) {
      setTimeout(() => {
        this.ngxUiLoaderService.stopLoader(this.loader.loaderId);
      }, 200);
      this.ngxUiLoaderService.stopAll()

      if (err.url?.includes('/appointment')) {
        this.toastr.warning(
          err.error.Message ?? err.error.message,
          'Warning!',
          { timeOut: 2000 }
        );
        return throwError(() => err.error.Message);
      }
       if (err.url?.includes('/voyage/start')) {
        this.toastr.warning(
          err.error.Message ?? err.error.message,
          'Warning!',
          { timeOut: 2000 }
        );
        return throwError(() => err.error.Message);
      }


      this.toastr.error(err.error.Message ?? err.error.message, 'Error!', {
        timeOut: 2000,
      });
      return throwError(() => err.error.Message);
    }

    if ([410, 404, 409].indexOf(err.status) != -1) {
      setTimeout(() => {
        if (this.loader?.loaderId) {
          this.ngxUiLoaderService.stopLoader(this.loader.loaderId);
        } else {
          this.ngxUiLoaderService.stopAll()
        }
      }, 200); 

       const message = err.error.Message ?? err.error.message;

      if (this.warningMessages.includes(message)) {
        this.toastr.warning(message, 'Warning!', {
          timeOut: 2000,
        });

        return throwError(() => err);
      }

      this.toastr.error(err.error.Message ?? err.error.message, 'Error!');

      return throwError(err.error.Message);
    }

    if (err.status == 0) {
      setTimeout(() => {
        this.ngxUiLoaderService.stopAll()
      }, 500);

      setTimeout(
        () => this.ngxUiLoaderService.stopLoader(this.loader.loaderId),
        500
      );

      this.toastr.error('Network Issue Or Some Error Occured', 'Error!', {
        timeOut: 5000,
      });
      return of('Some Error Occured');
    }
    throw err;
  }
}
